/*
 * useFileHooks.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 10 2023 mys Company
 */

import { useMutation } from '@tanstack/react-query'
import { axiosInstance, Methods } from '../../../config/axios/Axios'

export const useFileHooks = () => {
    let version = 'v1'
    let name = ''

    const { mutate: get } = useMutation({
        mutationFn: async () => {
            const response = await axiosInstance(version, 'files', null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: getOne } = useMutation({
        mutationFn: async (id) => {
            const response = await axiosInstance(version, 'files/' + id, null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: getBySourceId } = useMutation({
        mutationFn: async (params) => {
            const response = await axiosInstance(version, 'files/source/' + params.type + '/' + params.sourceId, null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: search } = useMutation({
        mutationFn: async (params) => {
            const response = await axiosInstance(version, 'city/search/' + params.query, null, Methods.GET, {}, {})
            return response
        },
    })

    const { mutate: post } = useMutation({
        mutationFn: async (model) => {
            const response = await axiosInstance(version, 'files', null, Methods.POST, {}, { model })
            return response
        },
    })

    const { mutate: uploads } = useMutation({
        mutationFn: async (body) => {
            const response = await axiosInstance(version, 'files/uploads', null, Methods.POST, { 'Content-Type': 'multipart/form-data' }, body)
            return response
        },
    })

    const { mutate: put } = useMutation({
        mutationFn: async (model) => {
            const response = await axiosInstance(version, 'files', null, Methods.PUT, {}, { model })
            return response
        },
    })

    const { mutate: deleted } = useMutation({
        mutationFn: async (id) => {
            const response = await axiosInstance(version, 'files/' + id, null, Methods.DELETE, {}, null)
            return response
        },
    })
    return { get, getOne, getBySourceId, post, put, deleted, uploads }
}
